module.exports = __webpack_public_path__ + "static/enimeris-logo-website-blue-f9abcd4a6a9d4591ce8155a5eebbe9c1.png";